<template>
  <el-dialog
    :close-on-click-modal="false"
    width="500px"
    :title="title"
    :visible.sync="currentVisible"
    @keyup.enter.native="onSubmit()">
    <question-error-message-form
      v-if="visible"
      v-loading="loading"
      ref="form"
      :batch-id="batchId"/>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="text"
                 @click="onReload">重置
      </el-button>
      <el-button @click="currentVisible = false">取消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="onSubmit">保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

import QuestionErrorMessageForm from '@/views/question-error-message/components/QuestionErrorMessageForm'

export default {
  mixins: [],
  components: {QuestionErrorMessageForm},
  props: {
    batchId: [Number, String],
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentVisible: this.visible,
      title: '配置题目不通过选项',
      loading: false,
    }
  },
  computed: {},
  watch: {
    visible (val) {
      if (this.currentVisible !== this.visible) {
        this.currentVisible = this.visible
      }
    },
    currentVisible () {
      if (this.currentVisible !== this.visible) {
        this.$emit('update:visible', this.currentVisible)
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    onSubmit () {
      this.loading = true
      this.$refs.form.onSubmit().then((value) => {
        this.$emit('submit-success', value)
        this.currentVisible = false
      }).finally(() => {
        this.loading = false
      })
    },
    onReload () {
      this.loading = true
      this.$refs.form.onReload().finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-error-message/components/ConfigQuestionErrorMessageDialog.vue